module.exports = __webpack_public_path__ + "media/images/case-studies/wandiful-f9d3c9b8cbff7a85bfaa3edf1acc46db.png";